module.exports = __webpack_public_path__ + "static/media/mars-double.f43a9fd9.svg";